import React, { useState, useEffect, useMemo } from "react";
import "./App.css";
import axios from 'axios';

function App() {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [data, setData] = useState([]);
  const [filterOptions, setFilterOptions] = useState({
    categories: [],
    subCategories: {},
    months: [],
    salesOffices: [],
    materials: [],
    mainSeries: [],
    subSeries: [],
  });
  const [filters, setFilters] = useState({
    category: "",
    subCategory: "",
    month: "",
    salesOffice: "",
    material: "",
    mainSeries: "",
    subSeries: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(30);
  const [isLoading, setIsLoading] = useState(false);

  const categoryMapping = useMemo(() => ({
    电脑散热器: [
      "笔记本散热器",
      "电脑风扇",
      "基础散热器",
      "热管散热器",
      "散热配件",
      "水冷散热器",
    ],
    电源: ["台式机电源"],
    机箱机壳: ["机箱"],
    其他: ["电源附件", "机箱附件", "其", "水冷附件"],
    周边产品: ["台式机外围设备", "鼠标垫", "鼠标", "键盘", "LED 灯光照明"],
  }), []);

  const seriesMapping = useMemo(() => ({
    机箱: ["MATREXX", "CK", "CH", "CC", "MORPHEUS", "CG", "MACUBE", "SMARTER", "E-SHIELD", "WAVE", "CYCLOPS", "QUADSTELLAR"],
    台式机电源: ["PK-D", "PF", "PX-G", "PQ-M", "PM-D", "DQ-M-V2L", "DE", "DN", "DQ-ST", "PL-D", "PN-D", "PN-M", "PX-P", "DQ-M-V3L", "DA", "DQ-M-V2L WH", "PK-H", "PQ-G", "DA-M", "DQ-M"],
    笔记本散热器: ["N SERIES", "MULTI CORE", "WIND PAL", "U SERIES"],
    电脑风扇: ["FC", "CF", "MF", "FT", "FK", "RF", "XFAN", "TF"],
    基础散热器: ["GAMMA", "CK", "THETA", "ALTA", "BETA", "UD"],
    热管散热器: ["AK", "ASSASSIN", "GAMMAXX", "ICE EDGE", "AN"],
    散热配件: ["DM", "Z SERIES", "��件包", "AM5 Thermal Paste Guard", "EK", "DS"],
    水冷散热器: ["LE", "LT", "MYSTIQUE", "LD", "LS", "GAMMAXX LIQUID", "CASTLE", "CASTLE EX", "CASTLE OEM", "LS OEM", "GAMMAXX OEM"],
    电源附件: ["PCIE-E"],
    机箱附件: ["PIXEL", "Air Panel"],
    水冷附件: ["LS LOGO", "配件包"],
    鼠标: ["MC", "MG"],
    台式机外围设备: ["FH", "SC", "Convertor", "GH-01", "Vertical-GPU-Bracket", "ST500", "M-desk", "PEC300"],
  }), []);

  useEffect(() => {
    if (data.length > 0) {
      const categories = Object.keys(categoryMapping);
      const subCategories = {};
      categories.forEach((category) => {
        subCategories[category] = categoryMapping[category];
      });

      const newFilterOptions = {
        categories: categories,
        subCategories: subCategories,
        months: [...new Set(data.map((item) => item["发票/交货单过账日期"].substring(0, 7)))].filter(Boolean).sort(),
        salesOffices: [
          ...new Set(data.map((item) => item["销售办公室描述"])),
        ].filter(Boolean),
        materials: [...new Set(data.map((item) => item["物  料"]))].filter(
          Boolean
        ),
        mainSeries: [...new Set(data.map((item) => item["产品主系列"]))].filter(
          Boolean
        ),
        subSeries: [...new Set(data.map((item) => item["产品次系列"]))].filter(
          Boolean
        ),
      };
      setFilterOptions(newFilterOptions);
    }
  }, [data, categoryMapping]);

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    setFile(file);
    setFileName(file.name);

    const formData = new FormData();
    formData.append("file", file);

    setIsLoading(true);  // 开始加载

    try {
      const response = await axios.post('http://152.136.33.187:5709/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 30000  // 设置超时时间为5000毫秒
      });
      console.log("Full response:", response);
      if (response && response.data) {
        setData(response.data.data);
        console.log("Data set:", response.data.data);
      } else {
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    } finally {
      setIsLoading(false);  // 结束加载
    }
  };

  const handleFilterChange = (filterName, value) => {
    setFilters((prevFilters) => {
      const newFilters = { ...prevFilters, [filterName]: value };
      if (filterName === "category") {
        newFilters.subCategory = "";
        newFilters.mainSeries = "";
      }
      if (filterName === "subCategory") {
        newFilters.mainSeries = "";
      }
      return newFilters;
    });
    // 重置当前页面到第一页
    setCurrentPage(1);
  };

  const filteredData = useMemo(() => {
    return data.filter((item) => {
      if (!item["发票/交货单过账日期"]) {
        console.warn("Item missing 发票/交货单过账日期:", item);
        return false;
      }

      const itemMonth = item["发票/交货单过账日期"].substring(0, 7);

      return (
        (!filters.category || item["产品类别(一级)"] === filters.category) &&
        (!filters.subCategory || item["产品类别(二级)"] === filters.subCategory) &&
        (!filters.month || itemMonth === filters.month) &&
        (!filters.salesOffice || item["销售办公室描述"] === filters.salesOffice) &&
        (!filters.material || item["物  料"].toString() === filters.material) &&
        (!filters.mainSeries || item["产品主系列"] === filters.mainSeries) &&
        (!filters.subSeries || item["产品次系列"] === filters.subSeries)
      );
    });
  }, [data, filters]);

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return filteredData.slice(startIndex, startIndex + itemsPerPage);
  }, [filteredData, currentPage, itemsPerPage]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleItemsPerPageChange = (event) => {
    const newItemsPerPage = Number(event.target.value);
    const newTotalPages = Math.ceil(filteredData.length / newItemsPerPage);
    const newCurrentPage = Math.min(currentPage, newTotalPages);
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(newCurrentPage);
  };

  const totalQuantity = useMemo(() => {
    return filteredData.reduce((sum, item) => sum + (parseFloat(item["开票/交货单数量"]) || 0), 0);
  }, [filteredData]);

  const renderFilterSelect = (optionKey, filterKey, label) => {
    let options = filterOptions[optionKey] || [];
    if (optionKey === "subCategories") {
      options = filterOptions.subCategories[filters.category] || [];
    } else if (optionKey === "mainSeries") {
      if (filters.subCategory) {
        options = seriesMapping[filters.subCategory] || [];
      } else {
        options = [];
      }
    }
    return (
      <select
        value={filters[filterKey]}
        onChange={(e) => handleFilterChange(filterKey, e.target.value)}
        disabled={
          (optionKey === "subCategories" && !filters.category) ||
          (optionKey === "mainSeries" && !filters.subCategory)
        }
      >
        <option value="">{label}</option>
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
    );
  };

  return (
    <div className="app-container">
      {!file ? (
        <div className="file-upload">
          <input
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileUpload}
            style={{ display: "none" }}
            id="fileInput"
          />
          <label htmlFor="fileInput" className="upload-button">
            加载销售数据
          </label>
        </div>
      ) : (
        <div className="file-info">
          <label htmlFor="fileInput" className="upload-button">
            加载销售数据
          </label>
          <span>{fileName}</span>
          <input
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileUpload}
            style={{ display: "none" }}
            id="fileInput"
          />
        </div>
      )}

      {isLoading ? (
        <div className="loading-indicator">
          <div className="spinner"></div>
          <p>正在加载数据，请稍候...</p>
        </div>
      ) : (
        <>
          {data.length > 0 && (
            <div className="filters">
              {renderFilterSelect("categories", "category", "选择品类")}
              {renderFilterSelect("subCategories", "subCategory", "选择二级类别")}
              {renderFilterSelect("mainSeries", "mainSeries", "选择主系列")}
              {renderFilterSelect("months", "month", "选择月份")}
              {renderFilterSelect("salesOffices", "salesOffice", "选择销售办公室")}
              {renderFilterSelect("materials", "material", "选择物料")}
              {renderFilterSelect("subSeries", "subSeries", "选择次系列")}
            </div>
          )}

          {data.length > 0 && (
            <div className="data-table">
              <table>
                <thead>
                  <tr>
                    <th>产品类别(一级)</th>
                    <th>产品类别(二级)</th>
                    <th>发票/交货单过账日期</th>
                    <th>销售办公室描述</th>
                    <th>物  料</th>
                    <th>产品主系列</th>
                    <th>产品次系列</th>
                    <th>开票/交货单数量</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedData.map((item, index) => (
                    <tr key={index}>
                      <td>{item["产品类别(一级)"]}</td>
                      <td>{item["产品类别(二级)"]}</td>
                      <td>{item["发票/交货单过账日期"]}</td>
                      <td>{item["销售办公室描述"]}</td>
                      <td>{item["物  料"]}</td>
                      <td>{item["产品主系列"]}</td>
                      <td>{item["产品次系列"]}</td>
                      <td>{item["开票/交货单数量"]}</td>
                    </tr>
                  ))}
                  <tr className="total-row">
                    <td colSpan="7" style={{textAlign: 'right', fontWeight: 'bold'}}>总数量:</td>
                    <td style={{fontWeight: 'bold'}}>{totalQuantity}</td>
                  </tr>
                </tbody>
              </table>
              <div className="table-footer">
                <div className="pagination">
                  <button 
                    onClick={() => handlePageChange(currentPage - 1)} 
                    disabled={currentPage === 1}
                  >
                    上一页
                  </button>
                  <span>{currentPage} / {totalPages}</span>
                  <button 
                    onClick={() => handlePageChange(currentPage + 1)} 
                    disabled={currentPage === totalPages}
                  >
                    下一页
                  </button>
                </div>
                <div className="items-per-page">
                  <label htmlFor="itemsPerPage">每页显示：</label>
                  <select 
                    id="itemsPerPage" 
                    value={itemsPerPage} 
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                  </select>
                </div>
                <div className="total-records">
                  总记录数: {filteredData.length}
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default App;
